import { Box, TableContainer, Typography } from "@mui/material";
import {
  FormattedManagementsList,
  ManagementsDetailHeader,
} from "../../../core/models/managements/managements.model";
import "./ManagementsHistoric.scss";
import { useTranslation } from "react-i18next";
import {
  getIncidenceIconTitle,
  getManagementStateData,
  incedenceTexts,
} from "../../../utils/components/managements/managements.util";
import ManagementsPagination from "../ManagementsPagination/ManagementsPagination";
import LoadingComponentComponent from "../../UI/LoadingComponentComponent/LoadingComponentComponent";
import { ManagementsListCard } from "../ManagementsListCard/ManagementsListCard";

interface ManagementsHistoricProps {
  managementsHistoricList: FormattedManagementsList[];
  totalRegistersQuery: number;
  isHistoricTableLoading: boolean;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  rowsPerPage: number;
  setRowsPerPage: React.Dispatch<React.SetStateAction<number>>;
  setManagementsDetailHeader: React.Dispatch<
    React.SetStateAction<ManagementsDetailHeader>
  >;
  pendingRequest: number;
  isTableFiltered: boolean;
}

const ManagementsHistoric = ({
  managementsHistoricList,
  totalRegistersQuery,
  isHistoricTableLoading,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  setManagementsDetailHeader,
  pendingRequest,
  isTableFiltered,
}: ManagementsHistoricProps) => {
  const { t } = useTranslation();

  return (
    <Box
      component="section"
      sx={{
        paddingBottom: { xs: "3.5rem", md: "5rem" },
        cursor: "pointer",
      }}
    >
      <Typography component="h3" variant="h3" paddingBottom="2.5rem">
        {t("Gestiones.Gestiones en curso")}
      </Typography>
      {!managementsHistoricList.length &&
        !isHistoricTableLoading &&
        !pendingRequest && (
          <Typography
            component="p"
            variant="body2"
            sx={{ color: "grey.700" }}
            paddingBottom={{ xs: "1.5rem", md: "2rem" }}
          >
            {isTableFiltered
              ? t("No hay resultados")
              : t("Gestiones.No hay histórico de gestiones")}
          </Typography>
        )}
      {isHistoricTableLoading && (
        <Box padding={"2rem 0"}>
          <LoadingComponentComponent
            isLoading={isHistoricTableLoading}
            backgroundColor={"transparent"}
            position={"relative"}
            height={"4rem"}
          />
        </Box>
      )}
      <Box component="article" className="last-bills-table">
        <TableContainer sx={{ overflow: "visible" }}>
          {managementsHistoricList.map(
            ({
              issueNumber,
              date,
              state,
              recordTextType,
              claimTextSubType,
              incidenceText,
              idSubType,
              socialReason,
              cups,
              cif,
            }) => {
              const { color, backgroundColor, icon, label } =
                getManagementStateData(state);

              const isIncidenceText = incedenceTexts.some(
                (incidenceMatchingText) =>
                  incidenceText.includes(incidenceMatchingText),
              );
              const incidenceIconTitle = getIncidenceIconTitle(
                incedenceTexts,
                incidenceText,
              );

              return (
                <>
                  <ManagementsListCard
                    backgroundColor={backgroundColor}
                    color={color}
                    icon={icon}
                    label={label}
                    socialReason={socialReason}
                    cups={cups}
                    cif={cif}
                    incidenceIconTitle={incidenceIconTitle}
                    date={date}
                    idSubType={idSubType}
                    issueNumber={issueNumber}
                    setManagementsDetailHeader={setManagementsDetailHeader}
                    recordTextType={recordTextType}
                    claimTextSubType={claimTextSubType}
                    incidenceText={incidenceText}
                    isIncidenceText={isIncidenceText}
                  />
                </>
              );
            },
          )}
          {!isHistoricTableLoading && (
            <ManagementsPagination
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              totalRegistersQuery={totalRegistersQuery}
            />
          )}
        </TableContainer>
      </Box>
    </Box>
  );
};

export default ManagementsHistoric;
